module.exports = __webpack_public_path__ + "static/media/start-game.92c8cc66.mp3";